/**
 * Initializes navigations with arrows and drag-to-scroll functionality.
 * @param {string} selector - The selector for the parent container.
 */
const initCarouselNavs = (selector = '.nav-wrapper-with-arrows') => {
    const navWrappers = document.querySelectorAll(selector);

    navWrappers.forEach(wrapper => {
        if (wrapper.dataset.initialized) return;

        const nav = wrapper.querySelector('.featured-collections-navigation');
        const btnLeft = wrapper.querySelector('.nav-arrow--left');
        const btnRight = wrapper.querySelector('.nav-arrow--right');

        if (!nav || !btnLeft || !btnRight) return;

        const updateArrows = () => {
            const { scrollLeft, scrollWidth, clientWidth } = nav;
            const isOverflowing = scrollWidth > clientWidth + 2;

            if (!isOverflowing) {
                btnLeft.hidden = true;
                btnRight.hidden = true;
                return;
            }

            btnLeft.hidden = scrollLeft <= 2;
            btnRight.hidden = scrollLeft + clientWidth >= scrollWidth - 2;
        };

        btnLeft.addEventListener('click', () => nav.scrollBy({ left: -250, behavior: 'smooth' }));
        btnRight.addEventListener('click', () => nav.scrollBy({ left: 250, behavior: 'smooth' }));

        let isDown = false;
        let startX, scrollLeftInitial;

        nav.addEventListener('mousedown', (e) => {
            isDown = true;
            nav.classList.add('is-dragging');
            startX = e.pageX - nav.offsetLeft;
            scrollLeftInitial = nav.scrollLeft;
        });

        const endDrag = () => { isDown = false; nav.classList.remove('is-dragging'); };
        nav.addEventListener('mouseleave', endDrag);
        nav.addEventListener('mouseup', endDrag);

        nav.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - nav.offsetLeft;
            const walk = (x - startX) * 2;
            nav.scrollLeft = scrollLeftInitial - walk;
        });

        nav.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);

        if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(updateArrows);
            observer.observe(nav);
        }

        wrapper.dataset.initialized = "true";

        updateArrows();
        setTimeout(updateArrows, 1200);
    });
};

document.addEventListener('DOMContentLoaded', () => initCarouselNavs());